import { Box, Typography, Button, Container } from '@mui/material';
import { m } from 'framer-motion';
import { varBounce, MotionContainer } from 'src/components/animate';
import { MaintenanceIllustration } from 'src/assets/illustrations';

// ------------------------------------------------
// TENANT SUSPENDED PAGE
// Shown when a tenant's subscription/account has been suspended.
// ------------------------------------------------
export default function TenantSuspendedPage() {
  return (
    <Container component={MotionContainer} sx={{ textAlign: 'center', py: 10 }}>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" gutterBottom>
          Account Suspended
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{ color: 'text.secondary', mb: 5 }}>
          This organization&apos;s account has been temporarily suspended. Please contact your
          administrator or reach out to MeruDesk support for assistance.
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <MaintenanceIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
      </m.div>

      <Button
        size="large"
        variant="contained"
        href="mailto:support@merudesk.com"
      >
        Contact Support
      </Button>
    </Container>
  );
}
